export default "__VITE_ASSET__BVEuOkLX__"